import React, { ReactNode, CSSProperties } from 'react';
import FixedAspectRatio from '../layout/FixedAspectRatio';

interface IProps {
  outerAspectRatio: number;
  contentAspectRatio: number;
  children: ReactNode;
}

/**
 * Crops and centres content to fill in available space of an area of
 * `outerAspectRatio`. The `contentAspectRatio` must be provided.
 *  Otherwise it's not possible to know whether to cut sides or
 * top/bottom.
 */
export default function Crop({ contentAspectRatio, outerAspectRatio, children }: IProps) {
  // If content is wider than the desired viewing `outerAspectRatio`
  // then make it wider than the container so that left and right
  // sides are cropped. Otherwise make it as width as the container so
  // that the top and bottom are cropped.
  const width = (contentAspectRatio > outerAspectRatio
                 ? contentAspectRatio / outerAspectRatio
                 : 1);

  const height = (contentAspectRatio > outerAspectRatio
                  ? 1
                  : outerAspectRatio / contentAspectRatio);

  const style: CSSProperties = {
    position: 'absolute',
    top: `${(1 - height) / 2 * 100}%`,
    left: `${(1 - width) / 2 * 100}%`,
    width: `${width * 100}%`,
    height: `${height * 100}%`,
  };

  return (
    <FixedAspectRatio aspectRatio={outerAspectRatio}>
      <div style={style}>
        {children}
      </div>
    </FixedAspectRatio>
  );
}
